module.exports = __webpack_public_path__ + "static/media/overhead_squat-01.ea558786.png";